import { z } from 'zod';

import Timestamp from '@/store/modules/models/global/Timestamp';

const ImportedContacts = z.array(z.object({
    fingerprint: z.string(),
    data: z.unknown(),
    errors: z.unknown().nullable(),
    is_valid: z.boolean(),
    created_at: Timestamp,
    updated_at: Timestamp,
  }));

export default ImportedContacts;
